import { connect } from 'react-redux';
import { addToMediaTrack } from 'redux/modules/embed/actions';

import { addAudioToTrack } from 'redux/modules/embed/actions/audio';
import {
  hasMediaSelector,
  projectTypeByAssets,
} from 'redux/modules/embed/selectors';
import { pushModal } from 'redux/modules/modal';
import { Dispatch, State } from 'redux/types';
import { PropsOf } from 'types';
import TranscriptStatusDisplay, {
  TranscriptStatusDisplayProps as Props,
} from './TranscriptStatusDisplay';

type StateProps = Pick<Props, 'hasMedia' | 'projectTypeByAssets'>;
type DispatchProps = Pick<Props, 'onClickAddAudio' | 'onClickAddVideo'>;

const mapStateToProps = (state: State): StateProps => ({
  hasMedia: hasMediaSelector(state),
  projectTypeByAssets: projectTypeByAssets(state),
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  onClickAddAudio: () => {
    dispatch(addAudioToTrack());
    dispatch(pushModal({ name: 'AddAudioModal' }));
  },
  onClickAddVideo: () => {
    dispatch(addToMediaTrack());
    dispatch(pushModal({ name: 'AddMediaModal' }));
  },
});

const component = connect(
  mapStateToProps,
  mapDispatchToProps,
)(TranscriptStatusDisplay);
export type TranscriptStatusDisplayProps = PropsOf<typeof component>;
export default component;
